import classNames from "classnames";

import { HaveQuestionMarkIcon } from "@components/Icons";

type HaveQuestionCardProps = {
  email?: string | null;
  phone?: string | null;
  className?: string;
};

/** Contact sidebar card used on patient-facing payment / statement pages. */
export function HaveQuestionCard({ email, phone, className }: HaveQuestionCardProps) {
  return (
    <div className={classNames("rounded-2xl border border-gray-200 bg-white", className)}>
      <div className="border-b p-4 pb-2">
        <HaveQuestionMarkIcon />
        <h2 className="mb-2 mt-6 text-xl font-medium text-gray-800">Have a Question?</h2>
        <p className="mb-4 text-sm leading-6 text-gray-600">
          Something look off or just have a question? No problem, please call or email us and we&apos;ll help
          out.
        </p>
      </div>
      <div className="p-4">
        {email && <p className="mb-2 text-sm leading-6 text-gray-600">Email : {email}</p>}
        {phone && <p className="text-sm leading-6 text-gray-600">Phone Number : {phone}</p>}
      </div>
    </div>
  );
}
